import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCopy, FiCheck } = FiIcons;

const CopyButton = ({ text, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!text) return;
    
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (!text) return null;

  return (
    <button
      onClick={handleCopy}
      className={`p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all active:scale-90 ${className}`}
      title="Copy to clipboard"
    >
      <SafeIcon icon={copied ? FiCheck : FiCopy} className={`text-[10px] ${copied ? 'text-emerald-500' : ''}`} />
    </button>
  );
};

export default CopyButton;